import { render, staticRenderFns } from "./teamMember-v2.vue?vue&type=template&id=55c67850&scoped=true&"
import script from "./teamMember-v2.vue?vue&type=script&lang=js&"
export * from "./teamMember-v2.vue?vue&type=script&lang=js&"
import style0 from "./teamMember-v2.vue?vue&type=style&index=0&id=55c67850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c67850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c67850')) {
      api.createRecord('55c67850', component.options)
    } else {
      api.reload('55c67850', component.options)
    }
    module.hot.accept("./teamMember-v2.vue?vue&type=template&id=55c67850&scoped=true&", function () {
      api.rerender('55c67850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/teamMember-v2.vue"
export default component.exports